var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQlt45(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 9 13 A 2 2 0 1 1  5,13 A 2 2 0 1 1  9 13 z",
    transform: "translate(-1,-1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 9 13 A 2 2 0 1 1  5,13 A 2 2 0 1 1  9 13 z",
    transform: "translate(15.5,-5.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 9 13 A 2 2 0 1 1  5,13 A 2 2 0 1 1  9 13 z",
    transform: "translate(32,-1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 9 13 A 2 2 0 1 1  5,13 A 2 2 0 1 1  9 13 z",
    transform: "translate(7,-4.5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 9 13 A 2 2 0 1 1  5,13 A 2 2 0 1 1  9 13 z",
    transform: "translate(24,-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 9,26 C 17.5,24.5 30,24.5 36,26 L 38,14 L 31,25 L 31,11 L 25.5,24.5 L 22.5,9.5 L 19.5,24.5 L 14,10.5 L 14,25 L 7,14 L 9,26 z ",
    style: {
      strokeLinecap: "butt"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9,26 C 9,28 10.5,28 11.5,30 C 12.5,31.5 12.5,31 12,33.5 C 10.5,34.5 10.5,36 10.5,36 C 9,37.5 11,38.5 11,38.5 C 17.5,39.5 27.5,39.5 34,38.5 C 34,38.5 35.5,37.5 34,36 C 34,36 34.5,34.5 33,33.5 C 32.5,31 32.5,31.5 33.5,30 C 34.5,28 36,28 36,26 C 27.5,24.5 17.5,24.5 9,26 z ",
    style: {
      strokeLinecap: "butt"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.5,30 C 15,29 30,29 33.5,30",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,33.5 C 18,32.5 27,32.5 33,33.5",
    style: {
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQlt45);
export default __webpack_public_path__ + "static/media/qlt45.4b58d14ce80eb6c12f0cbae18bc3ed2a.svg";
export { ForwardRef as ReactComponent };